import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { mcpOrgCredentialsQueryKey } from "./useMcpOrgCredentials";

/**
 * Removes a server's org-wide token, leaving the org secret in place. Members
 * who connected the server with their own account keep their access.
 */
export function useDeleteMcpOrgCredential(orgId: string | undefined) {
  const { mcpRegistryService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (serverId: string) =>
      mcpRegistryService.deleteOrgCredential(serverId, orgId!),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: mcpOrgCredentialsQueryKey(orgId),
      });
    },
  });
}
